import * as React from 'react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilLockUnlocked } from '@coreui/icons'

export default function PasswordField({ name, readOnly, placeholder, inputProps }) {
  const [showPassword, setShowPassword] = React.useState(false)
  const handleClickShowPassword = () => setShowPassword((show) => !show)

  return (
    <div className="input-group mb-3">
      <input
        type={showPassword ? 'text' : 'password'}
        className="form-control form-control-sm"
        placeholder={placeholder}
        aria-label={placeholder}
        aria-describedby="basic-addon2"
        disabled={readOnly}
        {...inputProps}
      />
      <button
        className="btn btn-sm btn-primary"
        id="basic-addon2"
        type="button"
        onClick={!readOnly && handleClickShowPassword}
        disabled={readOnly}
      >
        {showPassword ? <CIcon icon={cilLockLocked} /> : <CIcon icon={cilLockUnlocked} />}
      </button>
    </div>
  )
}
